import React from 'react';
import { Select } from 'antd';
import { Box } from '../../../shared/components';

const { Option } = Select;
const TIPO_BONIFICACION_PRECIO_FIJO = 2;

export default function SelectBonificacionesEstaticas({
  maxNumBonificacionesEstaticas,
  bonificacionesEstaticasSeleccionadas,
  bonificacionesEstaticas,
  onChange,
  disabled,
  hayBonificacionPrecioAlzaAplicada,
}) {
  const bonificacionesFiltradas = bonificacionesEstaticas.filter(({ id, tipo }) => {
    let valida = true;
    if (hayBonificacionPrecioAlzaAplicada) {
      valida = tipo !== TIPO_BONIFICACION_PRECIO_FIJO;
    }
    const bonificacionYaSeleccionada = bonificacionesEstaticasSeleccionadas.find(bonificacion => bonificacion.id === id);
    valida = valida && !bonificacionYaSeleccionada;
    return valida;
  });

  const OptionsBonificacionesEstaticas = bonificacionesFiltradas.map(({ id, descripcion }) => <Option key={id} value={id}>{descripcion}</Option>);
  const OptionsBonificacionesEstaticasSinPrecioFijo = bonificacionesFiltradas.filter(({ tipo }) => tipo !== TIPO_BONIFICACION_PRECIO_FIJO).map(({ id, descripcion }) => <Option key={id} value={id}>{descripcion}</Option>);

  const SelectBonificacionesEstaticas = [];
  for (let i = 0; i < maxNumBonificacionesEstaticas; i += 1) {
    const bonificacionSeleccionadaId = bonificacionesEstaticasSeleccionadas[i] ? bonificacionesEstaticasSeleccionadas[i].id : undefined;
    const noSoyLaPrimeraLineaDeBonificacion = i > 0;
    const bonificacionPreviaSeleccionada = noSoyLaPrimeraLineaDeBonificacion && bonificacionesEstaticasSeleccionadas[i - 1] == undefined;
    const esUnTipoDeBonificacionSinPrecioFijo = (i > 1);
    const Options = esUnTipoDeBonificacionSinPrecioFijo ? [...OptionsBonificacionesEstaticasSinPrecioFijo] : [...OptionsBonificacionesEstaticas];
    if (bonificacionSeleccionadaId > 0) {
      const bonificacionSeleccionadaFromDB = bonificacionesEstaticas.find(({ id }) => id === bonificacionSeleccionadaId);
      if (bonificacionSeleccionadaFromDB) {
        const { id, descripcion } = bonificacionSeleccionadaFromDB;
        Options.unshift(<Option key={id} value={id}>{descripcion}</Option>);
      }
    }
    const key = `select-${i}`;
    SelectBonificacionesEstaticas.push(
      <Box mb="16" key={key}>
        <Select
          disabled={disabled || bonificacionPreviaSeleccionada}
          style={{ width: '100%' }}
          onChange={(idBonificacion) => {
            onChange({ idBonificacion, posicion: i });
          }}
          allowClear
          value={bonificacionSeleccionadaId}
        >
          {Options}
        </Select>
      </Box>,
    );
  }
  return SelectBonificacionesEstaticas;
}
